import Auth from '../api/auth';
import { emitter } from 'shared/helpers/mitt';

const parseErrorCode = error => Promise.reject(error);

let sessionExpiredToastShown = false;

const handleSessionExpiry = () => {
  if (sessionExpiredToastShown) return;
  sessionExpiredToastShown = true;
  emitter.emit('newToastMessage', {
    message:
      'Your session has expired. Please refresh the page and log in again — any unsent messages were not delivered.',
  });
};

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => {
      if (error?.response?.status === 401) {
        handleSessionExpiry();
      }
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
